import { Card } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

interface EventCardSkeletonProps {
  variant?: 'loading' | 'error';
}

export function EventCardSkeleton({
  variant = 'loading',
}: EventCardSkeletonProps) {
  const isError = variant === 'error';
  const skeletonColor = isError ? 'bg-red-100' : 'bg-gray-200';
  const cardBorder = isError ? 'border-red-200 border' : '';

  return (
    <Card className={`overflow-hidden ${cardBorder}`}>
      <div className="flex">
        {/* Thumbnail skeleton */}
        <div
          className={`w-16 h-16 flex-shrink-0 ${skeletonColor} ${!isError ? 'animate-pulse' : ''} flex items-center justify-center`}
        >
          {isError && <AlertTriangle className="w-6 h-6 text-red-400" />}
        </div>

        {/* Content skeleton */}
        <div className="flex-1 ps-3 min-w-0">
          <div className="flex items-center justify-between gap-2">
            {/* Left content skeleton */}
            <div className="flex-1 min-w-0">
              {/* Event icon and action skeleton */}
              <div className="flex items-center gap-2 mb-1">
                <div
                  className={`w-4 h-4 ${skeletonColor} rounded ${!isError ? 'animate-pulse' : ''}`}
                />
                <div
                  className={`h-4 ${skeletonColor} rounded ${!isError ? 'animate-pulse' : ''} w-24`}
                >
                  {isError && (
                    <span className="text-xs text-red-600 font-medium px-2">
                      Failed to load
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Right content skeleton - timestamp */}
            <div className="flex flex-col flex-1 min-w-0 gap-1">
              <div
                className={`h-3 ${skeletonColor} rounded ${!isError ? 'animate-pulse' : ''} w-20 ml-auto`}
              />
              <div className="flex flex-row">
                <div
                  className={`h-3 ${skeletonColor} rounded ${!isError ? 'animate-pulse' : ''} w-16 flex-auto`}
                />
                <div
                  className={`h-3 ${skeletonColor} rounded ${!isError ? 'animate-pulse' : ''} w-12 flex-auto ml-2`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
